import { history } from 'umi';
import {deleteCookie, getCookie} from "@/utils/cookie";
import {setIsLogin} from '@/states/store'
import {wsStore} from '@/states/ws'
import { getQuery } from '.';
import { isOEM, redirectToOem } from './oem';
// import * as Sentry from '@sentry/react'


export const logOut=()=>{
  // Sentry.captureMessage(`logOut curWebsocket type:${wsStore?.webSocketState} , userId :${getCookie('userId')}`)
  if(isOEM()){
    redirectToOem()
    return
  } 
    deleteCookie('userId')
    deleteCookie('token')
    wsStore?.close();
    setIsLogin(false)
    let logOutUrl='/'
    if(getQuery()?.shareCode){
      logOutUrl='/?shareCode='+getQuery()?.shareCode
    }
    if(getQuery()?.code){
      logOutUrl='/?code='+getQuery()?.code
    }
    history.push({
      pathname:logOutUrl
    })
    wsStore.onPortLogout()
    location.reload()
}

export const logoutReload=()=>{
  if(isOEM()){
    redirectToOem()
    return
  } 
  setIsLogin(false)
  let logOutUrl='/'
  if(getQuery()?.shareCode){
    logOutUrl='/?shareCode='+getQuery()?.shareCode
  }
  if(getQuery()?.code){
    logOutUrl='/?code='+getQuery()?.code
  }
  history.push({
    pathname:logOutUrl
  })
  location.reload()
}